const URLS = {
  refreshToken: '/refresh_token',
  login: '/login',
  modPW: '/user/modpwd',
  dict: '/getDict', // 数据字典
  roleDict: 'getRoleDict',
  empDict: '/getEmpDict',
  idCode: '/getIDCode',
  menuTree: '/getTreeRes',
  getID: '/getID',
  getJobTitleDict: '/getJobTitleDict',
  getPartnerDict: '/getPartnerDict',
  getPartTypeDict: '/getPartTypeDict',
  getSupplierDict: '/getSupplierDict',
  getEmpNameDict: '/getEmpNameDict',
  getAddressBookDict: '/getAddressBookDict',
  getAddressBookDict2: '/getAddressBookDict2',
  getIncomeOutlayTypeDict: '/getIncomeOutlayTypeDict',
  getPOSupplierDict: '/getPOSupplierDict',
  getRefIDDict: '/getRefIDDict',
  getBomDict: '/getBomDict',
  getSODict: '/getSODict',
  getSODetailDict: '/getSODetailDict',
  getPartNo: 'getPartNo',
  getBomNoDict: '/getBomNoDict',
  getExpenseUseDict: '/getExpenseUseDict',
  getOrgDict: 'getOrgDict', //  机构字典
  // excel上传
  impDo: '/imp/do',
  impPage: '/imp/page',
  impDownTemp: '/imp/downtemp',
  impDownHis: '/imp/downhis',
  // 附件管理
  attUpload: '/att/upload',
  attDel: '/att/del',
  attDown: '/att/download',
  attList: '/att/list',
  // 审核
  audit: '/audit',
  printPDF: '/print/pdf',
  // 角色管理
  roleList: '/role/list',
  roleAdd: '/role/add',
  roleInfo: '/role/info',
  roleMod: '/role/mod',
  roleDel: '/role/del',
  roleExp: '/role/exp',
  rolePage: '/role/page',
  // 用户管理
  userList: '/user/list',
  userPage: '/user/page',
  userAdd: '/user/add',
  userInfo: '/user/info',
  userMod: '/user/mod',
  userLock: '/user/lock',
  userClearLock: '/user/clearlock',
  userClose: '/user/close',
  userBatchClose: '/user/batchclose',
  userInitPwd: '/user/initpwd',
  userAuthTree: '/user/authTree',
  userRoleCal: '/user/roleCal',
  userExp: '/user/exp',
  // 工作日设置
  dimdateListOne: '/dimdate/listone',
  dimdateSetWork: '/dimdate/setwork',
  // 数据库备份
  backdbDown: '/backdb/down',
  // 日志查询
  loginLogList: '/loginLog/list',
  userLogList: '/userLog/list',
  // 机构管理
  orgPage: '/org/page',
  orgAdd: '/org/add',
  orgInfo: '/org/info',
  orgMod: '/org/mod',
  orgDel: '/org/del',
  orgClose: '/org/close',
  orgTree: '/org/tree',
  orgExp: '/org/exp',
  orgCloseCancel: '/org/closecancel',
  // 员工管理
  empPage: '/emp/page',
  empAdd: '/emp/add',
  empInfo: '/emp/info',
  empMod: '/emp/mod',
  empLeave: '/emp/leave',
  empExp: '/emp/exp',
  empNormal: '/emp/becomenormal',
  // 合作伙伴
  partnerPage: '/partner/page',
  partnerAdd: '/partner/add',
  partnerInfo: '/partner/info',
  partnerMod: '/partner/mod',
  partnerDel: '/partner/del',
  partnerExp: '/partner/exp',
  // 通讯录
  addressbookList: '/addressbook/list',
  addressbookAdd: '/addressbook/add',
  addressbookInfo: '/addressbook/info',
  addressbookMod: '/addressbook/mod',
  addressbookDel: '/addressbook/del',
  addressbookLeave: '/addressbook/leave',
  // 零件信息
  partPage: '/part/page',
  partGetID: '/part/getid',
  partAdd: '/part/add',
  partInfo: '/part/info',
  partMod: '/part/mod',
  partDel: '/part/del',
  partExp: '/part/exp',
  partExpStock: '/part/expstock',
  partModPS: '/part/modPS',
  partModPP: '/part/modPP',
  partExpIO: '/part/expio',
  partExpPO: '/part/exppo',
  partExpSO: '/part/expso',
  // 零件-采购
  partpurList: '/partpur/list',
  partpurAdd: '/partpur/add',
  partpurMod: '/partpur/mod',
  partpurDel: '/partpur/del',
  partinfobypn: '/part/infobypn',
  // Bom
  bomPage: '/bom/page',
  bomCheckNo: '/bom/checkno',
  bomSave: '/bom/save',
  bomInfo: '/bom/info',
  bomInfoByNo: '/bom/infobyno',
  bomInfoExp: '/bom/infoexp',
  bomDel: '/bom/del',
  bomExp: '/bom/exp',
  bomCostDetail: '/bomcost/list',
  bomCostDetailExp: '/bomcost/exp',
  impBomPart: '/imp/bompart',
  // Bom组成
  bomPartList: '/bompart/list',
  bomPartPage: '/bompart/page',
  bomPartExp: '/bompart/exp',
  // 客户管理
  custPage: '/cust/page',
  custExp: '/cust/exp',
  // 销售订单主表
  soPage: '/so/page',
  soGetID: '/so/getid',
  soCheckID: '/so/checkid',
  soInfo: '/so/info',
  soSaveMain: '/so/savemain',
  soDel: '/so/del',
  soExp: '/so/exp',
  soPayDetail: '/so/paydetail',
  soPayExp: '/so/payexp',
  soInvoice: '/so/invoice',
  // 销售订单明细
  soListDetail: '/so/listdetail',
  soPageDetail: '/so/pagedetail',
  soSaveDetail: '/so/savedetail',
  soCalUnitPrice: '/so/calUnitPrice',
  // 销售查询(管理)
  // 销售明细(订单)
  soqueryOrderExp: '/soquery/order/exp',
  // 销售明细(未发货)
  soqueryOutPage: '/soquery/out/page',
  soqueryOutDetail: '/soquery/out/detail',
  soqueryOutExp: '/soquery/out/exp',
  // 成本对比
  soqueryCostDiffExp: '/soquery/costdiff/exp',
  // 销售明细(物料)
  soqueryPartExp: '/soquery/part/exp',
  // 成本明细
  soqueryCostDetailPage: '/soquery/costdetail/page',
  soqueryCostDetailExp: '/soquery/costdetail/exp',
  // 销售汇总
  soquerySalesTotalList: '/soquery/salestotal/list',
  soquerySalesTotalExp: '/soquery/salestotal/exp',
  // 收入/支出
  inoutPage: '/inout/page',
  inoutList: '/inout/list',
  inoutAdd: '/inout/add',
  inoutInfo: '/inout/info',
  inoutMod: '/inout/mod',
  inoutDel: '/inout/del',
  inoutExp: '/inout/exp',
  // 出入库
  inventoryPage: '/inventory/page',
  inventoryList: '/inventory/list',
  inventoryInit: '/inventory/init',
  inventoryGetID: '/inventory/getid',
  inventoryCheckID: '/inventory/checkid',
  inventoryAdd: '/inventory/add',
  inventorySave: '/inventory/save',
  inventoryInfo: '/inventory/info',
  inventoryMod: '/inventory/mod',
  inventoryDel: '/inventory/del',
  inventoryExpDetail: '/inventory/expdetail',
  // 出入库明细
  inventoryDetailList: '/inventory/detail/list',
  inventoryDetailPage: '/inventory/detail/page',
  // 出借归还
  lrPage: '/lr/page',
  lrDetail: '/lr/detail',
  lrExp: '/lr/exp',
  // 供应商
  supplierPage: '/supplier/page',
  supplierExp: '/supplier/exp',
  // 采购订单主表
  poPage: '/po/page',
  poGetID: '/po/getid',
  poCheckID: '/po/checkid',
  poInfo: '/po/info',
  poSaveMain: '/po/savemain',
  poDel: '/po/del',
  poExp: '/po/exp',
  poPayDetail: '/po/paydetail',
  poPayExp: '/po/payexp',
  poInvoice: '/po/invoice',
  // 采购订单明细
  poListDetail: '/po/listdetail',
  poSaveDetail: '/po/savedetail',
  poPageDetail: '/po/pagedetail',
  poCalUnitPrice: '/po/calUnitPrice',
  // Mrp
  mrpPage: '/mrp/page',
  mrpExp: '/mrp/exp',
  // 采购查询
  // 采购明细(订单)
  poqueryOrderPage: '/poquery/order/page',
  poqueryOrderExp: '/poquery/order/exp',
  // 采购明细(未入库)
  poqueryNotInPage: '/poquery/notin/page',
  poqueryNotInDetail: '/poquery/notin/detail',
  poqueryNotInExp: '/poquery/notin/exp',
  // 采购明细(物料)
  poqueryDetailPage: '/poquery/detail/page',
  poqueryDetailExp: '/poquery/detail/exp',
  // 采购金额按年汇总_按供应商
  poqueryAulSumBySupplierList: '/poquery/aulsumsupplier/list',
  poqueryAulSumBySupplierExp: '/poquery/aulsumsupplier/exp',
  // 采购汇总
  poqueryTotalList: '/poquery/total/list',
  poqueryTotalExp: '/poquery/total/exp',
  // 入库误差-多入库
  poqueryInMorePage: '/poquery/inmore/page',
  poqueryInMoreExp: '/poquery/inmore/exp',
  // 出账误差
  poqueryPayPage: '/poquery/pay/page',
  poqueryPayExp: '/poquery/pay/exp',
  // 生产计划
  prodplanPage: '/prodplan/page',
  prodplanGetID: '/prodplan/getid',
  prodplanAdd: '/prodplan/add',
  prodplanCopy: '/prodplan/copy',
  prodplanInfo: '/prodplan/info',
  prodplanMod: '/prodplan/mod',
  prodplanDel: '/prodplan/del',
  prodplanPicking: '/prodplan/picking',
  prodplanCompletion: '/prodplan/completion',
  prodplanExp: '/prodplan/exp',
  // 待生产列表
  toprodPage: '/toprod/page',
  toprodExp: '/toprod/exp',
  // 项目管理
  projectPage: '/project/page',
  projectGetID: '/project/getid',
  projectCheckID: '/project/checkid',
  projectSave: '/project/save',
  projectInfo: '/project/info',
  projectDel: '/project/del',
  projectExp: '/project/exp',
  // 费用
  expensePage: '/expense/page',
  expenseGetID: '/expense/getid',
  expenseCheckID: '/expense/checkid',
  expenseSave: '/expense/save',
  expenseInfo: '/expense/info',
  expenseDel: '/expense/del',
  expenseExp: '/expense/exp',
  // 应收账款
  arPage: '/ar/page',
  arExp: '/ar/exp',
  apayPage: '/apay/page',
  apayExp: '/apay/exp',
  // 待开发票
  toKpPage: '/tokp/page',
  toKpExp: '/tokp/exp',
  // 待收发票
  toSpPage: '/tosp/page',
  toSpExp: '/tosp/exp'
}
const Actions = {
  sys: {
    role: {
      list: 'M101010401',
      add: 'M101010402',
      info: 'M101010403',
      mod: 'M101010404',
      del: 'M101010405',
      exp: 'M101010406'
    },
    user: {
      list: 'M101010501',
      add: 'M101010502',
      info: 'M101010503',
      mod: 'M101010504',
      lock: 'M101010505',
      clearLock: 'M101010506',
      close: 'M101010507',
      initPwd: 'M101010508',
      exp: 'M101010509',
      authTree: 'M101010510',
      roleCal: 'M101010511',
      modifyPwd: 'WERP'
    },
    dimdate: {
      list: 'M101010701',
      set: 'M101010702'
    },
    backdb: {
      down: 'M101010901'
    },
    loginLog: {
      list: 'M101030101'
    },
    userLog: {
      list: 'M101030201'
    }
  },
  org: {
    org: {
      list: 'M102010101',
      add: 'M102010102',
      info: 'M102010103',
      mod: 'M102010104',
      del: 'M102010105',
      close: 'M102010107',
      tree: 'M102010108',
      exp: 'M102010106',
      closeCancel: 'M102010109'
    },
    emp: {
      list: 'M102010301',
      add: 'M102010302',
      info: 'M102010303',
      mod: 'M102010304',
      exp: 'M102010306',
      leave: 'M102010307',
      normal: 'M102010308'
    }
  },
  erp: {
    partner: {
      list: 'M103010101',
      add: 'M103010102',
      info: 'M103010103',
      mod: 'M103010104',
      del: 'M103010105',
      exp: 'M103010106'
    },
    addressbook: {
      list: 'M103010111',
      add: 'M103010112',
      info: 'M103010113',
      mod: 'M103010114',
      del: 'M103010115',
      leave: 'M103010116'
    },
    part: {
      list: 'M103020101',
      add: 'M103020102',
      info: 'M103020103',
      mod: 'M103020104',
      del: 'M103020105',
      exp: 'M103020106',
      expstock: 'M103020107',
      expio: 'M103020116',
      exppo: 'M103020117',
      expso: 'M103020118',
      help: 'M103020119'
    },
    partpur: {
      list: 'M103020111',
      add: 'M103020112',
      mod: 'M103020114',
      del: 'M103020115'
    },
    bom: {
      list: 'M103020201',
      add: 'M103020202',
      info: 'M103020203',
      mod: 'M103020204',
      del: 'M103020205',
      imp: 'M103020206',
      exp: 'M103020207',
      expcost: 'M103020208',
      expBom: 'M103020209',
      costdetailexp: 'M103020210',
      imppart: 'M103020211',
      help: 'M103020212'
    },
    cust: {
      list: 'M103030101',
      add: 'M103030102',
      info: 'M103030103',
      mod: 'M103030104',
      del: 'M103030105',
      exp: 'M103030106'
    },
    so: {
      list: 'M103030201',
      add: 'M103030202',
      info: 'M103030203',
      mod: 'M103030204',
      del: 'M103030205',
      exp: 'M103030206',
      b07: 'M103030207',
      b08: 'M103030208',
      b09: 'M103030209',
      b10: 'M103030210',
      b11: 'M103030211',
      b12: 'M103030212',
      b13: 'M103030213',
      b14: 'M103030214',
      b15: 'M103030215',
      b15A: 'M103030221',
      b16: 'M103030216',
      b17: 'M103030217',
      print: 'M103030218',
      kp: 'M103030219',
      huo: 'M103030220',
      paid: 'M103030222',
      help: 'M103030223'
    },
    soqueryorder: {
      list: 'M103040101',
      exp: 'M103040102',
      tbu: 'M103040103'
    },
    soqueryout: {
      list: 'M103040201',
      exp: 'M103040202',
      detail: 'M103040203'
    },
    costdiff: {
      list: 'M103040301',
      exp: 'M103040302'
    },
    soquerypart: {
      list: 'M103040401',
      exp: 'M103040402'
    },
    soquerycostdetail: {
      list: 'M103040501',
      exp: 'M103040502'
    },
    soquerysalestotal: {
      list: 'M103040601',
      exp: 'M103040602'
    },
    supplier: {
      list: 'M103050101',
      add: 'M103050102',
      info: 'M103050103',
      mod: 'M103050104',
      del: 'M103050105',
      exp: 'M103050106'
    },
    mrp: {
      list: 'M103050201',
      exp: 'M103050202'
    },
    mrp2: {
      list: 'M1030302211',
      exp: 'M1030302212'
    },
    po: {
      list: 'M103050301',
      add: 'M103050302',
      info: 'M103050303',
      mod: 'M103050304',
      del: 'M103050305',
      exp: 'M103050306',
      b07: 'M103050307',
      b08: 'M103050308',
      b09: 'M103050309',
      b10a: 'M103050311',
      b10: 'M103050310',
      b11: 'M103050311',
      b12: 'M103050312',
      b13: 'M103050313',
      b14: 'M103050314',
      print: 'M103050315',
      imp: 'M103050316',
      kp: 'M103050317',
      huo: 'M103050318',
      paid: 'M103050319',
      help: 'M103050320'
    },
    poqueryOrder: {
      list: 'M103060101',
      exp: 'M103060102',
      tbu: 'M103060103'
    },
    poqueryNotIn: {
      list: 'M103060201',
      exp: 'M103060202',
      detail: 'M103060203'
    },
    poqueryDetail: {
      list: 'M103060301',
      exp: 'M103060302'
    },
    poqueryAulSumBySupplier: {
      list: 'M103060501',
      exp: 'M103060502'
    },
    poqueryTotal: {
      list: 'M103060401',
      exp: 'M103060402'
    },
    poqueryinmore: {
      list: 'M103060501',
      exp: 'M103060502'
    },
    poquerypay: {
      list: 'M103060601',
      exp: 'M103060602'
    },
    stock: {
      list: 'M103070101',
      add: 'M103070102',
      info: 'M103070103',
      mod: 'M103070104',
      del: 'M103070105',
      expDetail: 'M103070106',
      b07: 'M103070107',
      print: 'M103070108',
      imp: 'M103070109',
      edit: 'M103070110',
      help: 'M103070111'
    },
    lr: {
      list: 'M103070201',
      detail: 'M103070202',
      exp: 'M103070203'
    },
    prodplan: {
      list: 'M103080101',
      add: 'M103080102',
      info: 'M103080103',
      mod: 'M103080104',
      del: 'M103080105',
      picking: 'M103080106',
      completion: 'M103080107',
      exp: 'M103080108',
      b09: 'M103080109',
      help: 'M103080110'
    },
    toprod: {
      list: 'M103080201',
      exp: 'M103080202'
    },
    project: {
      list: 'M103080301',
      add: 'M103080302',
      info: 'M103080303',
      mod: 'M103080304',
      del: 'M103080305',
      exp: 'M103080306',
      help: 'M103080307'
    },
    inout: {
      list: 'M103090101',
      add: 'M103090102',
      info: 'M103090103',
      mod: 'M103090104',
      del: 'M103090105',
      exp: 'M103090106',
      imp: 'M103090107'
    },
    expense: {
      list: 'M103090201',
      add: 'M103090202',
      info: 'M103090203',
      mod: 'M103090204',
      del: 'M103090205',
      exp: 'M103090206',
      imp: 'M103090207'
    },
    ar: {
      list: 'M103090301',
      exp: 'M103090302'
    },
    apay: {
      list: 'M103090401',
      exp: 'M103090402'
    },
    tokp: {
      list: 'M103090501',
      exp: 'M103090502'
    },
    tosp: {
      list: 'M103090601',
      exp: 'M103090602'
    },
    sopd: {
      list: 'M103090701',
      exp: 'M103090702'
    },
    popd: {
      list: 'M103090801',
      exp: 'M103090802'
    }
  }
}
export default URLS
export { Actions }



// WEBPACK FOOTER //
// ./src/assets/js/urls.js